
import React from "react"
import { useNavigate } from 'react-router-dom'

import hotelcss from './css/hotelhotellist.module.css';
import { useEffect } from 'react';
import { useState } from 'react';
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";
import './css/tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from 'react-bootstrap/Button';

import DagstaatNode from '../customNodes/DagstaatNode';
import HotelSelection from '../customNodes/HotelSelection';
import moment from 'moment';

import {
    getMyLinkedhotels, gethotel
} from "../dbconnector/connector";

const Dagstaten = (props) => {
    const t = props.translation
    const [linkedhotels, setLinkedHotels] = useState({});
    const [tabs, setTabs] = useState([]);
    const [tabpanels, setTabPanels] = useState([]);
    const [selectedtab, setSelectedtab] = useState(0);
    const today = new Date();
    const [selectedHotel, setselectedHotel] = useState(null);
    const [selectedDate, setSelectedDate] = useState(addDays(new Date(), 1).toLocaleDateString('en-CA'));

    //dop something after loading page
    useEffect(() => {
        try {
            setSelectedtab(Number(sessionStorage.getItem('selectedroostertabid')))

            if ([2, 4].includes(props.rights)) {
                document.getElementById("adminfilterbox").style.display = "block";
                document.getElementById("searchboxhotel").style.display = "block";
                document.getElementById("searchboxdate").style.display = "block";
            }
            else {
                if ([3].includes(props.rights)) {
                    setselectedHotel(null)
                    document.getElementById("adminfilterbox").style.display = "none";
                    document.getElementById("searchboxhotel").style.display = "none";
                    document.getElementById("searchboxdate").style.display = "block";
                }
                else {
                    document.getElementById("adminfilterbox").style.display = "none";
                }
                setLinkedHotels({})
                const response = getMyLinkedhotels()
                response.then(res => {
                    if (res.status === 200) {
                        res.json().then(linkedhotels => {
                            setLinkedHotels(linkedhotels.hotels)
                        })
                    } else {
                        setErrorMessage(res.statusText)
                    }
                })
            }
        } catch (e) {
            setErrorMessage(t("error_retreivingData"))
        }
    }, []);

    const setselectedtab = (tabid) => {
    //    console.log(tabid)
        setSelectedtab(tabid)
        sessionStorage.setItem('selectedroostertabid', tabid)
    }
    const setDateSchedule = (e) => {

        setSelectedDate(e.target.value)

        if (selectedHotel !== null) {
            getHotelSchedule(selectedHotel, e.target.value);
        }
        else {
            //console.log(e.target.value)
            buildtabs(e.target.value)
        }
    }
    const setSelectedHotel = (e) => {
        setselectedHotel(e.target.value)
        getHotelSchedule(e.target.value, selectedDate);
    }
    const getHotelSchedule = (hotelID, SelectedDate) => {
        //console.log("getHotelSchedule date: ", moment(SelectedDate).format("YYYY-MM-DD"))
       // console.log("tabs ", tabs[0].props.children)
       setTabs([])
       setTabPanels([])
        gethotel(hotelID).then(res => {
            if (res.status === 200) {
                // setTabs(pre => [
                //     <Tab id={res.hotel.hotel_Id} >{res.hotel.Name}</Tab>
                // ]
                // )
                setTabPanels(pre => [
                    //<TabPanel id={"tabPanel" + res.hotel.Hotel_ID}>
                        <DagstaatNode rights={props.rights} hotel={res.hotel} hotelid={res.hotel.Hotel_ID} t={t} datum={moment(SelectedDate).format("YYYY-MM-DD")}/>
                    //</TabPanel>
                ]
                )
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    function getDate() {
        const today = addDays(new Date(), 1)
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const day = today.getDate();
        return `${day}-${month}-${year}`;
    }

    function addDays(date, days) {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    }

    useEffect(() => {
        if (props.rights === 3) {
            buildtabs(selectedDate)
        }
    }, [linkedhotels]);

    const buildtabs = (SelectedDate) => {
        console.log("tabs ", tabs)
        setTabs([])
        setTabPanels([])
        if (linkedhotels.length > 0) {
            linkedhotels.forEach((hotel, index) => {
                setTabs(pre => [...pre,
                <Tab id={"'" + hotel.hotel_Id + "'"} key={"'" + hotel.hotel_Id + "'"} onClick={() => setselectedtab(index)}>{hotel.Name}</Tab>
                ])
                if (!document.getElementById("tabPanel" + hotel.hotel_Id)) {
                    setTabPanels(pre => [...pre,
                    <TabPanel id={"tabPanel" + hotel.hotel_Id} key="0">
                        <DagstaatNode rights={props.rights} hotel={hotel} hotelid={hotel.hotel_Id} t={t} datum={moment(new Date(SelectedDate).toLocaleDateString('en-CA')).format("YYYY-MM-DD")} />
                    </TabPanel>
                    ])
                }
            })
        }
    }
    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <center><Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                        </div>
                    </div>
                </header>
                <div className="form" id="adminfilterbox">
                    <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
                    <br></br>
                    <div className="contentbox">
                        <div id="searchboxhotel" className="formElement">
                            <label className='labelcolor'>
                                {t('Hotel')}:
                            </label>
                            <HotelSelection isDisabled={false} data={{ fieldname: "nr_afd", selectedhotel: null, handleitemchange: setSelectedHotel }} valueneeded="hotel_id" checkapproval={false} selectedDate={selectedDate} />

                        </div>
                        <div id="searchboxdate" className="formElement">
                            <label className='labelcolor'>
                                {t('Date')}:
                            </label>
                            <input type="date" id="scheduledate" defaultValue={addDays(new Date(), 0).toLocaleDateString('en-CA')} onChange={setDateSchedule} max={addDays(new Date(), 0).toLocaleDateString('en-CA')}></input>

                        </div>

                    </div>
                </div>
                <div id="content" className="form">

                    {/* <label className='formtitle' style={props.rights === 2 ? { display: "none" } : { display: "block" }}>{t('Aanmakendagrooster')} {moment(new Date(selectedDate).toLocaleDateString('en-CA')).format("DD-MM-YYYY")}</label> */}
                    {/* <Tabs className="HotelTabs" id="taboverview" selectedIndex={selectedtab !== undefined ? selectedtab : 0}>
                        <TabList id="tablisthoteloverview">
                            {tabs}
                        </TabList> */}
                        {tabpanels}
                    {/* </Tabs> */}
                </div>
            </div>
        </>
    )
}

export default Dagstaten